import React from "react";

const DashboardContainer = (props) => {
  return (
    <div className="bg-white dark:bg-zinc-900 shadow-sm rounded-2xl border border-zinc-200 dark:border-zinc-800 w-full">
      {props.children}
    </div>
  );
};

export default DashboardContainer;
